export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_1.eec4a457.jpg";